module.exports = __webpack_public_path__ + "static/media/userIcon.59741cc7.svg";